import moment from 'moment';

// Column order and keys follow prepareRows, which is also what the XML export writes.
export const REPORT_COLUMNS = [
  ['name', 'Report Name'],
  ['target_file_info', 'Target File Info'],
  ['target_date_time', 'Target Date/Time'],
  ['target_term_ref', 'Target Term Ref'],
  ['operator', 'Operator'],
  ['target_folder', 'Target Folder'],
  ['fingerprint_master', 'Fingerprint Master'],
  ['matching_threshold', 'Matching Threshold'],
  ['metadata', 'Metadata'],
  ['start_time', 'Start Time'],
  ['end_time', 'End Time'],
  ['status', 'Status'],
  ['matched_isrc', 'Matched ISRC'],
  ['hh_mm_ss', 'HH:mm:ss'],
  ['in_seconds', 'In Seconds'],
  ['recording_title', 'Recording Title'],
  ['artiste', 'Artiste'],
  ['release_label', 'Release Label'],
  ['claimant_name', 'Claimant Name'],
  ['copyright_owner', 'Copyright Owner'],
  ['type_of_recording', 'Type of Recording'],
  ['authorization_start_date', 'Authorization Start Date'],
  ['claimant_party_id', 'Claimant Party ID'],
  ['first_release_date_global', 'First Release Date (Global)'],
  ['first_release_date_hong_kong', 'First Release Date (Hong Kong)'],
  ['membership_start_date', 'Membership Start Date'],
  ['membership_end_date', 'Membership End Date'],
  ['user_defined_1', 'User Defined 1'],
  ['user_defined_2', 'User Defined 2'],
  ['user_defined_3', 'User Defined 3'],
];

export function getTableHeaders() {
  return REPORT_COLUMNS.map(([, header]) => header);
}

export function jsonArrayToTableArray(jsonArray, addHeader) {
  const tableArray = jsonArray.map((item) => REPORT_COLUMNS.map(([key]) => item[key]));
  if (addHeader) {
    tableArray.unshift(getTableHeaders());
  }
  return tableArray;
}

// Report timestamps are epoch millis; an unset value must stay blank, not become 1970-01-01.
export function formatExportDateTime(value) {
  if (value === undefined || value === null || String(value).trim() === '') {
    return '';
  }
  const millis = Number(value);
  if (!Number.isFinite(millis)) {
    return value;
  }
  return moment(millis).format('YYYY-MM-DD HH:mm:ss');
}

// A3 landscape; 30 columns need a small font to fit the page width.
export const PDF_PAGE = { orientation: 'l', unit: 'pt', format: 'a3' };
export const PDF_TABLE_STYLES = { fontSize: 6, cellPadding: 2, overflow: 'linebreak' };
export const PDF_MARGIN = 20;
